import "../styles/objectives.scss"
import { data, items } from "../services/data.ts"
const Objectives = () => {
  return (
    <section id="objectives" className="objectives-section">
      <h2>Comprometimento com a excelência</h2>
      <div className="objectives-grid">
        {items.objectives.map((obj, index) => (
          <div key={index} className="objective-item">
            <h3>{obj.title}</h3>
            <p className="justify">{obj.desc}</p>

          </div>
        ))}

      </div>
    </section>
  )
}
export default Objectives